<p-dialog [(visible)]="display" [breakpoints]="{ '960px': '75vw', '640px': '100vw' }" [style]="{ width: '75vw' }">
	<ng-template pTemplate="header">
		<div class="w-100">
			<div class="flex">
				<fa-icon [icon]="['far', 'id-badge']" class="me-4" size="2x"></fa-icon>
				<div class="display-8 ms-1 my-auto">{{ header }}</div>
			</div>
			<p-divider></p-divider>
		</div>
	</ng-template>
	<div class="d-flex flex-column">
		<div class="w-100">
			<span class="p-float-label mt-4">
				<input pInputText #licenseKeyInput name="licenseKeyInput" type="text" [(ngModel)]="licenseKey" class="w-100" />
				<label for="licenseKeyInput">License Key</label>
			</span>
		</div>
		<div class="w-100">
			<span class="p-float-label mt-4">
				<input pInputText #licenseSecretInput name="licenseSecretInput" type="text" [(ngModel)]="licenseSecret" class="w-100" />
				<label for="licenseSecretInput">License Secret</label>
			</span>
		</div>
	</div>
	<ng-template pTemplate="footer">
		<app-record-control-footer
			[hideAdd]="true"
			[hideCancel]=""
			[hideDelete]="true"
			[hideSave]=""
			(onCancelChange)="display = false"
			(onSaveChange)="submit()"
			[saveDisabled]="!licenseKey || !licenseSecret"
		></app-record-control-footer>
	</ng-template>
</p-dialog>
